export const log = (name, body) => {
  const styleLog =
    'color: #3949AB; font-weight: bold; background-color: #FFF59D;';
  const time = timeEvent();
  console.groupCollapsed('%c ' + name + ' (' + time + '): ', styleLog);
  console.log('%c [Data]', 'color: #F44336;', JSON.stringify(body, null, 4));
  console.groupEnd();
};

export const logResponse = (name, body) => {
  const styleLog =
    'color: #3949AB; font-weight: bold; background-color: #FFF59D;';
  const time = timeEvent();
  console.groupCollapsed('%c ' + name + ' (' + time + '): ', styleLog);
  console.log('%c [Data]', 'color: #F44336;', body);
  console.groupEnd();
};

export const logAPI = (action, params, result = false) => {
  let styleLog = '';
  if (result) {
    styleLog = 'color: #3949AB; font-weight: bold; background-color: #bdcdeb;';
  } else {
    styleLog = 'color: #3949AB; font-weight: bold; background-color: #d2d2d2;';
  }

  const time = timeEvent();

  console.groupCollapsed('%c ' + action + ' (' + time + '): ', styleLog);
  if (result) {
    console.log(
      '%c [Params]',
      'color: #F44336;',
      JSON.stringify(params, null, 4),
    );
    console.log(
      '%c [Result]',
      'color: #F44336;',
      JSON.stringify(result, null, 4),
    );
  } else {
    console.log(
      '%c [Action]',
      'color: #F44336;',
      JSON.stringify(params, null, 4),
    );
  }
  console.groupEnd();
};

export const logBus = (event, params) => {
  const styleLog =
    'color: #3949AB; font-weight: bold; background-color: #82c785;';

  const time = timeEvent();

  console.groupCollapsed('%c ' + event + ' (' + time + '): ', styleLog);
  console.log(
    '%c [EventBus]',
    'color: #F44336;',
    JSON.stringify(params, null, 4),
  );
  console.groupEnd();
};

export const logEvent = (name, body) => {
  // const styleLog = 'color: #3949AB; font-weight: bold; background-color: #FFF59D;'
  //
  // const time = timeEvent()
  //
  // console.groupCollapsed('%c '+ name +' ('+ time +'): ', styleLog)
  // console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4))
  // console.groupEnd()
};

export const logEventBus = (event, params) => {
  // const styleLog = 'color: #3949AB; font-weight: bold; background-color: #82c785;'
  //
  // const time = timeEvent()
  //
  // console.groupCollapsed('%c '+ event +' ('+ time +'): ', styleLog)
  // console.log('%c [EventBus]', 'color: #F44336;', JSON.stringify(params, null, 4))
  // console.groupEnd()
};

export const logAction = (action, params, result = false) => {
  // let styleLog = ''
  // if(result){
  //     styleLog = 'color: #3949AB; font-weight: bold; background-color: #bdcdeb;'
  // }else{
  //     styleLog = 'color: #3949AB; font-weight: bold; background-color: #d2d2d2;'
  // }
  //
  //
  // const time = timeEvent()
  //
  // console.groupCollapsed('%c '+ action +' ('+ time +'): ', styleLog)
  // if(result){
  //     console.log('%c [Params]', 'color: #F44336;', JSON.stringify(params, null, 4))
  //     console.log('%c [Result]', 'color: #F44336;', JSON.stringify(result, null, 4))
  // }else{
  //     console.log('%c [Action]', 'color: #F44336;', JSON.stringify(params, null, 4))
  // }
  // console.groupEnd()
};

const timeEvent = () => {
  const date = new Date();
  let h = date.getHours();
  let m = 0;
  if (date.getMinutes() >= 10) m = date.getMinutes();
  else m = '0' + date.getMinutes();
  let s = 0;
  if (date.getSeconds() >= 10) s = date.getSeconds();
  else s = '0' + date.getSeconds();
  return h + ':' + m + ':' + s;
};
